import {
  getLoginShopid,
  getLanguage, getStorageCityId, getStorageRegion,
  getRegionByCookie,
} from '@RootCommon/utils'
import { commonRequestAll, commonRequest } from '@/common/utils/request'
import mainApi, { adApi } from '@/common/api/urls'

// 获取门店列表，依赖acctId, 账号相关的i18n信息就绪
export async function getAccountShopListApi (params: {
  acctIds: string,
  shopName: string,
  pageNo: number,
  pageSize: number,
}) {
  return commonRequestAll.post(
    mainApi.getShopListByAccount,
    params,
    {
      headers: {
        locale: getLanguage(),
        region: getRegionByCookie(), // getRegion会优先从url获取值，初次加载时，账号的region还未更新到url。
        cityId: getStorageCityId(),
        // currency: getCurrency(),
      },
    }
  )
}

export async function getSettledShopListApi () {
  return commonRequest.get(
    mainApi.getSettledShopList,
    {
      headers: {
        locale: getLanguage(),
        region: getRegionByCookie(),
        opCenterSelectedRegion: getRegionByCookie(),
      },
    },
  )
}

export async function getShopCloseReason (shopId: number) {
  return commonRequest.get(
    mainApi.getShopCloseReason,
    {
      params: { shopId },
    }
  )
}

export async function getShowImMsgBoxApi (shopId: number) {
  return commonRequest.get(
    mainApi.getShowImMsgBox,
    {
      params: {},
    }
  )
}